import { render, staticRenderFns } from "./ReportRecordList.vue?vue&type=template&id=1b595a2c"
import script from "./ReportRecordList.vue?vue&type=script&lang=js"
export * from "./ReportRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports